import { EpisodeDto } from "./types";
import { EpisodeMeta } from "./meta";

export const data: EpisodeDto[] = [
  // {
  //   id: 37,
  //   datetime: "2026-11-29T18:00:00.000Z",
  //   thumbnail: "/uploads/logos/RAIMZEAL.png",
  //   topic: "RAIMZEAL App Design Session",
  //   topicRichText: "RAIMZEAL App<br/>Design Session",
  //   tags: "AI Coach, Nutrition & Wellness, Women's Health",
  //   guests: [28],
  //   virtualLink: "",
  //   listeners: 0,
  //   liveListeners: 0,
  //   meta: {
  //     src: "/uploads/logos/RAIMZEAL.png",
  //     title:
  //       "FREE AI-enabled Health App created by the RAIMZEAL Health Foundation, Inc.",
  //     url: "raimzeal.com",
  //   },
  //   favorite: true,
  // },
  {
    id: 36,
    datetime: "2026-11-01T18:00:00.000Z",
    thumbnail: "/uploads/logos/ncdc.jpg",
    topic: "Health Ed Policies & Promotion",
    topicRichText: "Health Education, Policies & Promotion",
    tags: "Epidemiology, MEAL, Infodemic, Ebola II",
    guests: [26, 11],
    virtualLink: "",
    listeners: 0,
    liveListeners: 0,
    meta: {
      src: "/uploads/logos/ncdc.jpg",
      title:
        "Case Definitions for Ebola Viral Disease | Nigeria Centre for Disease Control NCDC",
      url: "ncdc.gov.ng",
    },
    series: "fc",
    favorite: true,
  },
  {
    id: 35,
    datetime: "2026-10-25T18:00:00.000Z",
    thumbnail: "/uploads/logos/bdi.png",
    topic: "Catalyzing Sustainable Economic Growth",
    summary:
      "Economic Transformation, Investment Promotion, and Sustainable Development in Bauchi State",
    tags: "Transparent, Self-Sufficient, #FindOneCampus",
    guests: [25],
    virtualLink: "",
    listeners: 0,
    liveListeners: 0,
    meta: {
      src: "/uploads/logos/bdi.png",
      title:
        "Land Mapping & Digital Structuring | FindOneCampus | ELI7 Foundation | BDI",
      url: "mx2bdi.com",
    },
    series: "fc",
    favorite: true,
  },
  {
    id: 34,
    datetime: "2026-10-18T19:00:00.000Z",
    thumbnail: "/uploads/logos/brightson.png",
    topic: "Product Design Thinking in Web3",
    topicRichText: "Product Design Thinking in <span>Web3</span>",
    tags: "_Personas, User Journey, Wallet Onboarding, Tokenization",
    guests: [24],
    virtualLink: "https://x.com/i/spaces/1qxvveQZDWqxB",
    listeners: 10,
    liveListeners: 10,
    meta: {
      src: "/uploads/logos/brightson.png",
      title:
        "Premium Automobile Sales & Services | Transparent Pricing | Brightson Autos",
      url: "brightsonautos.com",
      cta: "Contact Sales",
    },
    series: "fc",
    favorite: true,
  },
  {
    id: 33,
    datetime: "2026-10-01T18:00:00.000Z",
    thumbnail: "/uploads/logos/wale.png",
    topic: "Shaping Young Minds For Future Nigeria",
    tags: ["Indigenous Research", "STEM", "#KidsCanCode"],
    guests: [14],
    virtualLink: "#",
    listeners: 0,
    liveListeners: 0,
    meta: {
      src: "/uploads/logos/wale.png",
      title:
        "The Nexus of Innovation and Real World Applications | WALE University",
      url: "lab.wale.university",
      cta: "Get Started",
    },
    series: "fc",
  },
  {
    id: 32,
    datetime: "2026-09-27T18:00:00.000Z",
    thumbnail: "/uploads/logos/expo-cbt.png",
    topic: "Security Compliance and Data Privacy",
    summary: "ExpoCBT Weekly Q&A Session",
    tags: "SOC 2 Type II, PCI DSS, HIPAA, FERPA",
    virtualLink: "https://x.com/i/spaces/1wGWjlOywaeKQ",
    listeners: 5,
    liveListeners: 5,
    meta: EpisodeMeta.expo,
    series: "ai",
    favorite: true,
  },
  {
    id: 31,
    datetime: "2026-09-13T18:00:00.000Z",
    thumbnail: "/uploads/logos/expo-cbt.png",
    topic: "Roles & Permissions Schema (RBAC)",
    summary: "ExpoCBT Weekly Q&A Session",
    tags: EpisodeMeta.expo.tags,
    virtualLink: "https://x.com/i/spaces/1OxwbnYPqEdJB",
    listeners: 4,
    liveListeners: 3,
    meta: EpisodeMeta.expo,
    series: "ai",
    favorite: true,
  },
  {
    id: 30,
    datetime: "2026-08-30T18:00:00.000Z",
    thumbnail: "/uploads/logos/siiqo.png",
    topic: "Distribution Hacks for Tech Founders",
    tags: ["Go-To-Market", "Partnerships", "Community"],
    guests: [9],
    virtualLink: "https://x.com/i/spaces/1rGmqplenOZGy",
    listeners: 5,
    liveListeners: 5,
    meta: EpisodeMeta.siiqo,
    series: "fc",
    favorite: true,
  },
  {
    id: 29,
    datetime: "2026-08-23T18:00:00.000Z",
    thumbnail: "/uploads/logos/expo-cbt.png",
    topic: "SRS Core Modules & Data Models",
    summary:
      "SDLC Phase 2 - Define Core Modules, Data Models and Relationships. Publish ERD.md on GitHub.",
    tags: EpisodeMeta.expo.tags,
    virtualLink: "https://x.com/i/spaces/1oKMvNnXVrzGQ",
    listeners: 2,
    liveListeners: 2,
    meta: EpisodeMeta.expo,
    series: "ai",
  },
  {
    id: 28,
    datetime: "2026-08-16T18:00:00.000Z",
    thumbnail: "/uploads/logos/expo-cbt.png",
    topic: "PRD Scope, Budget & Timelines",
    summary:
      "SDLC Phase 1 - Define Goals, Scope, Budget, and Timelines. Publish PRD.md, SRS.md on GitHub.",
    tags: EpisodeMeta.expo.tags,
    virtualLink: "https://x.com/i/spaces/1dKrPrloYvAJX",
    listeners: 5,
    liveListeners: 3,
    meta: EpisodeMeta.expo,
    series: "ai",
  },
  {
    id: 27,
    datetime: "2026-08-09T18:00:00.000Z",
    topic: "AI/ML Engineering - Course Overview",
    topicRichText: "AI/ML Engineering<br/>Course Overview",
    summary:
      "Design & Develop ExpoCBT using Claude AI. Train & Deploy ML Model to Detect Exam Malpractice",
    tags: EpisodeMeta.expo.tags,
    guests: [20, 17],
    virtualLink: "https://x.com/i/spaces/1OGwbnlzNlmKB",
    listeners: 24,
    liveListeners: 13,
    meta: EpisodeMeta.expo,
    series: "ml",
    favorite: true,
  },
  {
    id: 26,
    datetime: "2026-07-26T18:00:00.000Z",
    thumbnail: "/uploads/logos/binx.jpg",
    topic: "Binx AI Design Session",
    topicRichText: "Binx AI<br/>Design Session",
    tags: ["AI Chat", "Image Generation", "Voice Transcription"],
    guests: [22, 23],
    virtualLink: "https://youtu.be/DNRfPTblMJA",
    virtualPlatform: "yt",
    listeners: 58,
    liveListeners: 10,
    meta: {
      src: "/uploads/logos/binx.jpg",
      title:
        "WhatsApp AI Agent & Assistant | Web Search | Image Generation & More",
      url: "usebinx.com",
      cta: "Get Started",
    },
    favorite: true,
  },
  {
    id: 24,
    datetime: "2026-07-19T19:00:00.000Z",
    thumbnail: "/uploads/logos/edusphere.png",
    topic: "Smart EduSphere Design Session",
    tags: ["AI-Native", "Multi-Tenant", "OIDC Secure"],
    guests: [21],
    virtualLink: "https://x.com/i/spaces/1dKrPPVvdbqJX",
    listeners: 4,
    liveListeners: 3,
    meta: {
      src: "/uploads/logos/edusphere.png",
      title:
        "All-In-One School Management OS. Admissions, Bursary, CBT Exams, Rep...",
      url: "vicomeg.com",
      cta: "Register Now",
    },
  },
  {
    id: 23,
    datetime: "2026-07-12T19:00:00.000Z",
    thumbnail: "/uploads/logos/thesinova.png",
    topic: "Empirical Analysis & Decision Making",
    tags: ["Inference", "Classification", "Forecast"],
    guests: [20],
    virtualLink: "https://x.com/i/spaces/1yGBeeAYNgMKN",
    listeners: 4,
    liveListeners: 2,
    series: "fc",
    meta: {
      src: "/uploads/logos/thesinova.png",
      title:
        "High-performance Solutions at the Intersection of Academia & Techno...",
      url: "thesinova.com",
      cta: "Contact Us",
    },
  },
  {
    id: 22,
    datetime: "2026-07-08T09:00:00.000Z",
    thumbnail: "/uploads/logos/oau.png",
    topic: "Event-Driven Programming Pt.2",
    summary:
      "A Virtual Guest Lecture + Vibe Coding Session at the Dept. of Software Engineering, OAU",
    tags: ["Control Flow", "BOM & DOM", "async/await"],
    virtualLink: "https://youtu.be/N8ZCWAtmcF8",
    virtualPlatform: "yt",
    listeners: 111,
    liveListeners: 30,
    series: "fc",
    meta: EpisodeMeta.oau,
    favorite: true,
  },
  {
    id: 21,
    datetime: "2026-07-05T19:00:00.000Z",
    thumbnail: "/uploads/logos/lani.png",
    topic: "LANI App Design Session",
    tags: ["Order", "Sell", "Deliver"],
    guests: [19],
    virtualLink: "https://x.com/i/spaces/1dGYllAbQAoKX",
    listeners: 11,
    liveListeners: 9,
    meta: {
      src: "/uploads/logos/lani.png",
      title:
        "Lani | Order, Sell & Deliver. All In One Platform. Meals & Essentials Services.",
      url: "lani.ng",
      cta: "Download Now",
    },
    _notes: {
      user: "https://play.google.com/store/apps/details?id=com.savic3916.lanieats",
      merchant:
        "https://play.google.com/store/apps/details?id=com.lanieats.merchants",
      rider: "https://play.google.com/store/apps/details?id=com.lanieats.rider",
    },
    favorite: true,
  },
  {
    id: 20,
    datetime: "2026-07-01T09:00:00.000Z",
    thumbnail: "/uploads/logos/oau.png",
    topic: "Event-Driven Programming Pt.1",
    summary:
      "A Virtual Guest Lecture at the Department of Computer Science & Engineering, OAU",
    tags: ["Control Flow", "BOM & DOM", "async/await"],
    virtualLink: "https://youtu.be/cGoyAmGwDog",
    virtualPlatform: "yt",
    listeners: 163,
    liveListeners: 60,
    series: "fc",
    meta: EpisodeMeta.oau,
  },
  {
    id: 19,
    datetime: "2026-06-28T19:00:00.000Z",
    thumbnail: "/uploads/logos/npower.jpg",
    topic: "SOW: Government Subcontractors",
    tags: ["Scope", "Deliverables", "Constraints"],
    guests: [17, 18],
    virtualLink: "https://x.com/i/spaces/1wGWjjElmNNKQ",
    listeners: 17,
    liveListeners: 17,
    series: "fc",
    meta: {
      src: "/uploads/logos/inec.png",
      title:
        "Continuous Voter Registration - INEC Independent National Electorial Com...",
      url: "cvr.inecnigeria.org",
      cta: "Register Now",
    },
    favorite: true,
  },
  {
    id: 18,
    datetime: "2026-06-26T19:00:00.000Z",
    topic: "Study of Pragmatics & Cryptography",
    tags: ["Anagram", "Pangram", "Palindrome"],
    guests: [16],
    virtualLink: "https://x.com/i/spaces/1pKkOOEXPnXKj",
    listeners: 8,
    liveListeners: 6,
    series: "fc",
    favorite: true,
  },
  {
    id: 17,
    datetime: "2026-06-21T19:00:00.000Z",
    thumbnail: "/uploads/logos/siiqo.png",
    topic: "Comms Strategy for Startups",
    tags: ["Clarity", "Alignment ", "Tone"],
    guests: [10],
    virtualLink: "https://x.com/i/spaces/1DGleemXPqzJL",
    listeners: 22,
    liveListeners: 21,
    series: "fc",
    meta: EpisodeMeta.siiqo,
  },
  {
    id: 16,
    datetime: "2026-06-19T19:00:00.000Z",
    thumbnail: "/uploads/logos/awore.png",
    topic: "ACID Traits for Agile Workflows",
    tags: ["PRD", "Sprints", "Time Estimates"],
    guests: [15],
    virtualLink: "https://x.com/i/spaces/1yxBeeBWbpWJN",
    listeners: 7,
    liveListeners: 6,
    series: "fc",
    meta: {
      src: "/uploads/logos/awore.png",
      title: "Handcrafted Textile Brand Creating Intentional Àdìrẹ Fabrics",
      url: "awo_oore",
      cta: "Contact Us",
      social: "ig",
    },
  },
  {
    id: 15,
    datetime: "2026-06-14T20:00:00.000Z",
    thumbnail: "/uploads/logos/tan.png",
    topic: "Youth Politics & Voter Pre-Registration Data",
    tags: ["Democratic", "Progressive", "Transparent"],
    guests: [14],
    virtualLink: "https://x.com/i/spaces/1pKdRRAwWWNJW",
    listeners: 10,
    liveListeners: 8,
    series: "fc",
    meta: {
      src: "/uploads/logos/tan.png",
      title: "Independent, Community-Driven Social & Economic Empowerme...",
      url: "tribeallianceng",
      cta: "Get Involved",
      social: "fb",
    },
  },
  {
    id: 14,
    datetime: "2026-06-12T19:00:00.000Z",
    thumbnail: "/uploads/logos/distrokid.jpg",
    topic: "Gospel Music & Lossless Audio Compression",
    _notes: {
      url: "https://distrokid.com/hyperfollow/jamiahgodfrey/jesus-you-are-real",
    },
    tags: ["Sample Rate", "WAV", "FLAC"],
    guests: [13],
    virtualLink: "https://x.com/i/spaces/1RJjppApPbNKw",
    listeners: 21,
    liveListeners: 17,
    series: "fc",
    meta: {
      src: "/uploads/logos/distrokid.jpg",
      title: 'Download & Listen to "Jesus You Are Real" by Jamiah Godfrey',
      url: "distrokid.com",
      cta: "Play Now",
    },
    favorite: true,
  },
  {
    id: 13,
    datetime: "2026-06-07T19:00:00.000Z",
    thumbnail: "/uploads/logos/thisday.png",
    topic: "ACID Traits for AI Workflows Pt.2",
    summary: "Keynotes from Onyebinamma Ebuka Peter's article by THISDAY",
    _notes: {
      headline:
        "From Writing Code to Designing Systems: How AI Is Redefining Software Engineering",
      url: "https://thisdaylive.com/2026/06/01/from-writing-code-to-designing-systems-how-ai-is-redefining-software-engineering",
    },
    tags: ["Prompting", "Architecture", "Judgement"],
    guests: [12],
    virtualLink: "https://x.com/i/spaces/1lKQRRgNYdyGE",
    listeners: 15,
    liveListeners: 12,
    series: "cs",
    meta: {
      src: "/uploads/logos/thisday.png",
      title:
        "From Writing Code to Designing Systems: How AI Is Redefining S...",
      url: "thisdaylive.com",
      cta: "Learn More",
    },
    favorite: true,
  },
  {
    id: 12,
    datetime: "2026-06-03T19:00:00.000Z",
    thumbnail: "/uploads/logos/snu-ri.jpg",
    topic: "ACID Traits for AI Workflows Pt.1",
    summary:
      "Keynotes from Madison Huang at Seoul National University (SNU) Robotics Institute",
    _notes: { yt: "https://youtu.be/dhMPSzedWNQ" },
    tags: ["Job Task", "Job Purpose", "AI FOMO"],
    virtualLink: "https://x.com/i/spaces/1dGYllLnveLKX",
    listeners: 3,
    liveListeners: 3,
    series: "cs",
    meta: {
      src: "/uploads/logos/snu-ri.jpg",
      title: "Madison Huang's Non-Linear Career | NVIDIA at SNU Robotics",
      url: "youtu.be/dhMPSzedWNQ",
      cta: "Watch Now",
    },
  },
  {
    id: 11,
    datetime: "2026-05-30T19:00:00.000Z",
    thumbnail: "/uploads/logos/ubth.png",
    topic: "Basic Routine Medical Investigations",
    tags: ["Urinalysis", "X-Ray", "ECG", "#Django"],
    guests: [11],
    notionUrl:
      "https://held-gambler-004.notion.site/Routine-Investigations-Modeling-36c6a7cc633c8017b911d6266fa82422",
    virtualLink: "https://x.com/i/spaces/1RKZzzBwanMKB",
    listeners: 66,
    liveListeners: 58,
    series: "fc",
    favorite: true,
  },
  {
    id: 10,
    datetime: "2026-05-28T19:00:00.000Z",
    thumbnail: "/uploads/logos/siiqo.png",
    topic: "Siiqo Design Session",
    tags: ["Marketplace", "Escrow", "Stablecoin"],
    guests: [9, 10],
    notionUrl:
      "https://held-gambler-004.notion.site/Siiqo-36c6a7cc633c8132842bf67ada4dd93d",
    virtualLink: "https://x.com/i/spaces/1qGvvvewvbkGB",
    listeners: 68,
    liveListeners: 42,
    meta: EpisodeMeta.siiqo,
    favorite: true,
  },
  {
    id: 9,
    datetime: "2026-05-17T19:00:00.000Z",
    thumbnail: "/uploads/logos/moniepoint.png",
    topic: "KPIs of World-Class Software Engineers",
    summary: "Keynotes from Tosin Eniolorunda's speech at The Platform Nigeria",
    _notes: { yt: "https://youtu.be/OeP5Rs96OGY" },
    tags: ["Ownership", "Mentorship", "Scalability"],
    guests: [7, 8],
    notionUrl:
      "https://held-gambler-004.notion.site/KPIs-of-World-Class-Engineers-3486a7cc633c8078980ded890c2c9cc6",
    virtualLink: "https://x.com/i/spaces/1mGPaLAgERYJN",
    listeners: 24,
    liveListeners: 14,
    series: "cs",
    favorite: true,
  },
  {
    id: 7,
    datetime: "2026-04-12T19:00:00.000Z",
    thumbnail: "/uploads/logos/grab.png",
    topic: "Grab.com from MVP to Product Market Fit",
    summary: "Keynotes from Anthony Tan's interview by CNBC Int'l",
    _notes: { x: "@InsideGrab", yt: "https://youtu.be/PR2194ddosg" },
    notionUrl:
      "https://held-gambler-004.notion.site/Grab-com-from-MVP-to-PMF-3406a7cc633c817aba03ed635c6f6253",
    virtualLink: "https://x.com/i/spaces/1YxNrZNPNnpxw",
    listeners: 33,
    liveListeners: 10,
    series: "cs",
    favorite: true,
  },
  {
    id: 6,
    datetime: "2026-04-05T19:00:00.000Z",
    thumbnail: "/uploads/logos/adiz.png",
    topic: "Brand-Led Growth Hacking",
    summary:
      "Designing a brand identity that drive sales and customer loyalty.",
    guests: [6],
    notionUrl:
      "https://held-gambler-004.notion.site/Brand-Led-Growth-Hacking-3336a7cc633c810692e6e80f80946edb",
    virtualLink: "https://x.com/i/spaces/1rGmqojWqzqGy",
    listeners: 46,
    liveListeners: 31,
    series: "fc",
    favorite: true,
  },
  {
    id: 5,
    datetime: "2026-03-29T19:00:00.000Z",
    thumbnail: "/uploads/logos/tetra.png",
    topic: "Tetra Design Session",
    summary: "Virtual Dollar Cards for Seamless Int'l Transactions",
    guests: [5],
    notionUrl:
      "https://held-gambler-004.notion.site/Tetra-3316a7cc633c81429fabfb80a8601f8d",
    virtualLink: "https://x.com/i/spaces/1nxeLyZOkXLJX",
    listeners: 41,
    liveListeners: 21,
    favorite: true,
  },
  {
    id: 4,
    datetime: "2026-03-22T19:00:00.000Z",
    thumbnail: "/uploads/logos/izivote.png",
    topic: "Izivote Design Session",
    summary: "Cloud-based Voting Platform for Events & Campaigns",
    guests: [4],
    notionUrl:
      "https://held-gambler-004.notion.site/Izivote-3206a7cc633c807dbd55c6fbb373ff37",
    virtualLink: "https://x.com/i/spaces/1XGygmPjeMkxM",
    listeners: 93,
    liveListeners: 33,
    favorite: true,
  },
  {
    id: 3,
    datetime: "2026-03-15T19:00:00.000Z",
    thumbnail: "/uploads/logos/bookin.png",
    topic: "Bookin Design Session",
    summary: "All-in-one Booking Platform for Creative Professionals",
    guests: [3],
    notionUrl:
      "https://held-gambler-004.notion.site/Bookin-3226a7cc633c81f1a9d8ebbce7bbc6b3",
    virtualLink: "https://x.com/i/spaces/1DxleEjawjlKL",
    listeners: 136,
    liveListeners: 112,
    favorite: true,
  },
  {
    id: 2,
    datetime: "2026-03-08T19:00:00.000Z",
    thumbnail: "/uploads/logos/scupex.png",
    topic: "Scupex Design Session",
    summary: "Cloud-based, Multi-tenant School Management Solution",
    guests: [2],
    notionUrl:
      "https://held-gambler-004.notion.site/Scupex-31b6a7cc633c81eba6adcdddbe8fa5a1",
    virtualLink: "https://x.com/i/spaces/1qGvvkLwDBAGB",
    listeners: 139,
    liveListeners: 103,
  },
];
